<template>
<div class="content__row">
	<div class="row__item">{{ address.country_name }}</div>
	<div class="row__item">{{ address.district }}</div>
	<div class="row__item">{{ address.region }}</div>
	<div class="row__item">{{ address.city }}</div>
	<div class="row__item">{{ address.street }}</div>
	<div class="row__item">{{ address.building_number }}</div>
	<div class="row__item">{{ address.index }}</div>
	<div class="row__item">{{ address.smirovaci }}</div>
</div>
</template>

<script>
export default {
	props: ['address']
}
</script>

<style scoped>
.row__item {
	width: 8vw;
}
.content__row {
	border: none !important;
	display: flex;
	flex-direction: row;
	align-items: center;
	min-height: 50px;
}
</style>
